/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
export const COLOR_MODES_STANDARD = {
    light: 'LIGHT',
    dark: 'DARK',
};
export const COLOR_MODES_INVERSE = 'INVERSE';
export const EUI_THEME_HIGH_CONTRAST_MODE_KEY = 'HCM';
export const EUI_THEME_OVERRIDES_KEY = 'overrides';
